module.exports = __webpack_public_path__ + "static/connection_science_r-277863d9bddb77d443113e9eadc46735.png";